export const COLUMN_VISIBILITY_PAGES = {
  projects: 'projects',
  items: 'items',
  singleProject: 'single-project',
  orderingAndReceiving: 'ordering-and-receiving',
  clientOrderingAndReceiving: 'client-ordering-and-receiving',
} as const;

export type ColumnVisibilityPage =
  (typeof COLUMN_VISIBILITY_PAGES)[keyof typeof COLUMN_VISIBILITY_PAGES];

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const normalizeColumnVisibilityPreference = <T extends string>(
  allowedKeys: readonly T[],
  value: unknown
): Partial<Record<T, boolean>> => {
  if (!isPlainObject(value)) {
    return {};
  }

  const allowed = new Set<string>(allowedKeys);
  const next: Partial<Record<T, boolean>> = {};

  Object.entries(value).forEach(([key, raw]) => {
    if (allowed.has(key) && typeof raw === 'boolean') {
      next[key as T] = raw;
    }
  });

  return next;
};

export const normalizeAssignmentColumnVisibility = (value: unknown): Record<number, boolean> => {
  if (!isPlainObject(value)) {
    return {};
  }

  const next: Record<number, boolean> = {};
  Object.entries(value).forEach(([key, raw]) => {
    const roleId = Number(key);
    if (Number.isInteger(roleId) && roleId > 0 && typeof raw === 'boolean') {
      next[roleId] = raw;
    }
  });

  return next;
};
